import { render, staticRenderFns } from "./LeaveStats.vue?vue&type=template&id=5183147a&scoped=true&"
import script from "./LeaveStats.vue?vue&type=script&lang=js&"
export * from "./LeaveStats.vue?vue&type=script&lang=js&"
import style0 from "./LeaveStats.vue?vue&type=style&index=0&id=5183147a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183147a",
  null
  
)

export default component.exports